var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as moment from "moment";
import { ApiModel } from "./api-model";
var BTSport = /** @class */ (function (_super) {
    __extends(BTSport, _super);
    function BTSport(data) {
        var _this = _super.call(this, data) || this;
        _this.active = false;
        _this.liveDate = new Date(_this.liveDate);
        _this.liveEnd = new Date(_this.liveEnd);
        return _this;
    }
    BTSport.prototype.GetTimeString = function () {
        return (moment(this.liveDate).format("DD/MM/YYYY HH:mm") +
            "-" +
            moment(this.liveEnd).format("HH:mm"));
    };
    BTSport.prototype.GetDescriptionShort = function () {
        if (this.description.length > 70) {
            return this.description.slice(0, 70) + "...";
        }
        else {
            return this.description;
        }
    };
    return BTSport;
}(ApiModel));
export { BTSport };



// WEBPACK FOOTER //
// ./src/app/models/bt-sport.ts.pre-build-optimizer.js